import HaloLayer from '../layers/HaloLayer';
import halo from '../core/map/halo';
import worldMap from '../core/map';

const LayerControls = (name) => require('../controls').get(name);

export const selectMarker = (marker, feature, layerName, context) => {
  if (marker instanceof L.Marker) {
    const layerControl = LayerControls(layerName);
    layerControl.highlight(marker, 'click');
    halo.remove();
    new HaloLayer(worldMap.getCurrent(), marker, feature, layerName, context);
  }
};



// WEBPACK FOOTER //
// ./src/scripts/shared/map.js